import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home" // 添加根路径重定向
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "user-login" */ "@/views/Login.vue"),
  },
  {
    path: "/fullScreenMonitor",
    name: "FullScreenMonitor", // 使用帕斯卡命名
    component: () =>
      import(
        /* webpackChunkName: "operation-monitor" */ "@/views/Monitor/OperationMonitor/OperationMonitor.vue"
      ),
  },
  {
    path: "/home",
    name: "Home", // 添加路由名称
    redirect: "/desktop", // 添加默认重定向
    component: Home,
    children: [
      {
        path: "/DevopsGroup",
        name: "DevopsGroup", 
        component: () => import(/* webpackChunkName: "devops-group" */ "@/views/Devops/DevopsDept/DevopsGroup.vue"),
      },
      {
        path: "/AddOrder",
        name: "AddOrder",
        component: () => import(/* webpackChunkName: "add-order" */ "@/views/WorkOrder/Dispatch/AddOrder.vue"),
      },
      {
        path: "/TransferOrder/:id",
        name: "TransferOrderDetail", // 添加有意义的名称
        component: () =>
          import(/* webpackChunkName: "transfer-order" */ "@/views/WorkOrder/Dispatch/TransferOrder.vue"),
      },
      {
        path: "/AddFence",
        name: "AddFence",
        component: () => import(/* webpackChunkName: "add-fence" */ "@/views/Vehicle/FenceManage/AddFence.vue"),
      },
      {
        path: "/Dispatch",
        name: "Dispatch",
        component: () => import(/* webpackChunkName: "dispatch" */ "@/views/WorkOrder/Dispatch/Dispatch.vue"),
      },
      {
        path: "/Audit",
        name: "Audit",
        component: () =>
          import(/* webpackChunkName: "audit" */ "@/views/BaseStationManage/PathAudit/Audit.vue"),
      },
      {
        path: "/Vehicle",
        name: "Vehicle",
        component: () =>
          import(/* webpackChunkName: "vehicle" */ "@/views/Vehicle/VehicleManage/VehicleManagement.vue"),
      },
      {
        path: "/VehicleInfo",
        name: "VehicleInfo",
        component: () =>
          import(/* webpackChunkName: "vehicle-info" */ "@/views/Vehicle/VehicleManage/VehicleInfo.vue"),
      },
      {
        path: "/AddNotice",
        name: "AddNotice",
        component: () =>
          import(/* webpackChunkName: "add-notice" */ "@/views/Vehicle/CustomNotice/components/AddNotice.vue"),
      },
      {
        path: "/PowerRecordDetail",
        name: "PowerRecordDetail",
        component: () =>
          import(
            /* webpackChunkName: "power-record-detail" */ "@/views/Vehicle/VehicleManage/components/power/PowerDetail.vue"
          ),
      },
      {
        path: "/AlarmDetails",
        name: "AlarmDetails",
        component: () =>
          import(
            /* webpackChunkName: "alarm-details" */ "@/views/Vehicle/VehicleManage/components/alarm/AlarmDetails.vue"
          ),
      },
      {
        path: "/PercentManagement",
        name: "PercentManagement",
        component: () =>
          import(
            /* webpackChunkName: "percent-management" */ "@/views/OtherServices/PercentManagement/PercentManagement.vue"
          ),
      },
      {
        path: "/UnitManagement",
        name: "UnitManagement",
        component: () => import(/* webpackChunkName: "unit-management" */ "@/views/UnitManagement/UnitManagement.vue"),
      },
      {
        path: "/desktop",
        name: "Desktop", // 添加名称
        component: () =>
          import(/* webpackChunkName: "desktop" */ "@/views/DeskTop.vue"), // 更新chunk名称
      },
      {
        path: "/AlarmMonitor",
        name: "AlarmMonitor",
        component: () =>
          import(
            /* webpackChunkName: "alarm-monitor" */ "@/views/Monitor/AlarmMonitor/AlarmMonitor.vue" // 更新chunk名称
          ),
      },
      {
        path: "/HistoryAlarm",
        name: "HistoryAlarm",
        component: () =>
          import(/* webpackChunkName: "history-alarm" */ "@/views/Monitor/AlarmMonitor/components/HistoryAlarm.vue"),
      },
      {
        path: "/AlarmSet",
        name: "AlarmSet",
        component: () => import(/* webpackChunkName: "alarm-set" */ "@/views/Monitor/AlarmSet/AlarmSet.vue"),
      },
      {
        path: "/BaseStationPowerRecord",
        name: "BaseStationPowerRecord",
        component: () =>
          import(
            /* webpackChunkName: "base-station-power" */ "@/views/Statistics/BaseStationPowerRecord/BaseStationPowerRecord.vue"
          ),
      },
      {
        path: "/PowerRecordMore",
        name: "PowerRecordMore",
        component: () =>
          import(
            /* webpackChunkName: "power-record-more" */ "@/views/Statistics/BaseStationPowerRecord/components/PowerRecordMore.vue"
          ),
      },
      {
        path: "/PowerDetail",
        name: "PowerDetail",
        component: () =>
          import(
            /* webpackChunkName: "power-detail" */ "@/views/Statistics/BaseStationPowerRecord/components/PowerDetail.vue"
          ),
      },
      {
        path: "/MapImages",
        name: "MapImages",
        component: () =>
          import(/* webpackChunkName: "map-images" */ "@/views/OtherServices/WaterTest/components/MapImages.vue"),
      },
    ],
  },
  {
    path: "*",
    name: "NotFound", // 添加有意义的名称
    component: () => import(/* webpackChunkName: "not-found" */ "@/views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;